// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06818f5b","407":"5efca15e","498":"fe4ca5b8","703":"d2304ab4","787":"53a61f91"}[chunkId] + ".chunk.js";
};